export default "__VITE_ASSET__p7W5lUHW__"